import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import PostControls from 'flarum/forum/utils/PostControls';
import Button from 'flarum/common/components/Button';
export default function () {
  extend(PostControls, 'userControls', function (items, post) {
    if (post.isHidden() || post.contentType() !== 'comment' || !post.canFlag()) return;
    items.add('flag', m(Button, {
      icon: "fas fa-flag",
      onclick: () => app.modal.show(() => import(/* webpackChunkName: 'forum/components/FlagPostModal', webpackMode: 'lazy-once' */ './components/FlagPostModal'), {
        post
      })
    }, app.translator.trans('flarum-flags.forum.post_controls.flag_button')));
  });
}flarum.reg.addChunkModule('487', '85', 'flarum-flags', 'forum/components/FlagPostModal');